import { Input } from 'antd';
import { OTPProps } from 'antd/es/input/OTP';
import styles from './one-time-password.module.scss';

interface OneTimePasswordProps extends OTPProps {}

export default function OneTimePassword({ ...restProps }: OneTimePasswordProps) {
  return (
    <Input.OTP {...restProps} prefixCls={styles.oneTimePassword} variant="borderless"></Input.OTP>
  );
}
